import "./src/styles/index.scss"

require('./src/components/prism-coldark-dark.css');